export const orderInfoAdapter = (data) => {
	return [
		{
			key: data?.trx_id + 'info',
			origin_order_id: data?.origin_order_id,
			created_at: data?.created_at,
			schedule_selected: data?.info?.schedule_selected ? data?.info?.schedule_selected : '-',
			operation_id: data?.operation_id,
			type_retirement: data?.pharmacy_detail?.type_retirement,
			trx_id: data?.trx_id,
		},
	];
};
